module.exports = __webpack_public_path__ + "img/hina-vip.4a58bba0.png";